<template>
  <main
    class="company page-main"
    :class="{
      'company-more-wrap': companyMore
    }"
  >
    <section class="company-visual" data-style="show">
      <picture>
        <source media="(min-width: 750px)" srcset="~@/static/image/company/pc/visual@3x.jpg 3x">
        <source media="(max-width: 750px)" srcset="~@/static/image/company/m/visual@3x.jpg 3x">
        <img src="~@/static/image/company/pc/visual.jpg" :alt="$t('company.head')">
      </picture>
    </section>

    <section class="page-heading-wrap">
      <h3 class="page-heading">{{ $t('company.head') }}</h3>
      <html-view :value="$t('company.copy')" class="page-heading-desc" />
    </section>

    <div>
      <tab
        :tab-list="tabList"
        class="tab-sticky"
        :index="0"
        @click:tab="onGoSticky"
      >
        <template v-slot:bar>
          <i class="tab-progress-bar" :style="`width: ${scrollPercentage}%`" />
        </template>

        <template v-slot:sub>
          <div class="tab-sub">
            <a :href="`#${$t('vision.name')}`" @click="onGoAnchor">{{ $t('vision.name') }}</a>
            <a :href="`#${$t('value.name')}`" @click="onGoAnchor">{{ $t('value.name') }}</a>
            <a :href="`#${$t('people.name')}`" @click="onGoAnchor">{{ $t('people.name') }}</a>
            <a :href="`#${$t('better.name')}`" @click="onGoAnchor">{{ $t('better.name') }}</a>
          </div>
        </template>
      </tab>
      <culture id="culture" class="sticky" />
    </div>

    <div>
      <tab
        :tab-list="tabList"
        class="tab-sticky"
        :index="1"
        @click:tab="onGoSticky"
      >
        <template v-slot:bar>
          <i class="tab-progress-bar" :style="`width: ${scrollPercentage}%`" />
        </template>
      </tab>
      <history id="history" class="sticky" />
    </div>

    <div>
      <tab
        :tab-list="tabList"
        class="tab-sticky"
        :index="2"
        @click:tab="onGoSticky"
      >
        <template v-slot:bar>
          <i class="tab-progress-bar" :style="`width: ${scrollPercentage}%`" />
        </template>

        <template v-slot:sub>
          <div class="tab-sub">
            <a :href="`#${$t('resolutions.name')}`" @click="onGoAnchor">{{ $t('resolutions.name') }}</a>
            <a :href="`#${$t('declaration.name')}`" @click="onGoAnchor">{{ $t('declaration.name') }}</a>
            <a :href="`#${$t('conduct.name')}`" @click="onGoAnchor">{{ $t('conduct.name') }}</a>
          </div>
        </template>
      </tab>
      <ethical id="ethical" class="sticky" :company-more="companyMore" />
    </div>

    <div v-if="companyMore" class="more">
      <button type="button" class="btn btn-fill" @click="companyMore = false">{{ $t('free-more') }}</button>
      <icon-chevron-down />
    </div>
  </main>
</template>
<script>
import observer from '@/mixins/observer'
import tabScrollbar from '@/mixins/tabScrollbar'
import contentsPage from '@/mixins/contentsPage'

export default {
  components: {
    iconChevronDown: () => import('@/static/svg/chevron-down.svg'),
    tab: () => import('@/components/base/Tab'),
    culture: () => import('@/views/company/Culture'),
    history: () => import('@/views/company/History'),
    ethical: () => import('@/views/company/Ethical')
  },
  mixins: [observer, tabScrollbar, contentsPage],
  data () {
    return {
      companyMore: true,
      tabList: [
        {
          params: { child: 'culture' },
          name: 'menuCompany.woowaCulture'
        },
        {
          params: { child: 'history' },
          name: 'menuCompany.history'
        },
        {
          params: { child: 'ethical' },
          name: 'menuCompany.ethicalManagement'
        }
      ]
    }
  },
  watch: {
    '$route.params.child' () {
      this.removeMore()
    }
  },
  mounted () {
    this.removeMore()
  },
  methods: {
    removeMore () {
      this.companyMore = true
      // if (!this.$route.params.child) {
      //   this.companyMore = true
      // }
      // if (this.$route.params.child && this.$route.params.child !== 'culture') {
      //   this.companyMore = false
      // }
    }
  }
}
</script>
